import react, { Fragment, useState, useEffect } from 'react'

import axios from 'axios'
import { toast } from 'react-toastify'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Container from 'react-bootstrap/Container'
import { Form } from 'react-bootstrap'
import {} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { AiOutlineLogout } from 'react-icons/ai'
import { Button, DatePicker, Layout, Grid, Input } from 'antd'
import moment from 'moment'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import dayjs from 'dayjs'
import Sidebar from './sidebarstudent'
import Header from './Headerstudent'
import {
  AluminiDistrictFind,
  AluminiStateFindAll,
  AluminiTalukaFind,
  AluminiUpdateProfile,
  DistrictFindAllApi,
  EventAluminiFindOne,
  StateFindAllApi,
  StudentEditProfileApi,
  StudentProfileApi,
  TalukaFindAllApi,
} from '../../ApiFile'
import MobileNavbar from './MobileNavbar'

const { Content } = Layout
const { useBreakpoint } = Grid

const EditStudentProfile = () => {
  const navigate = useNavigate()

  const memberId = sessionStorage.getItem('member_id')

  const [stateList, setStateList] = useState([])
  const [districtList, setDistrictList] = useState([])
  const [talukaList, setTalukaList] = useState([])

  const [file, setFile] = useState(null)
  const [pincode, setPincode] = useState('')
  const [studentMobNo, setStudentMobNo] = useState('')
  const [parentMobNo, setParentMobNo] = useState('')
  const [clgName, setClgName] = useState('')
  const [standard, setStandard] = useState('')

  const [city, setCity] = useState('')
  const [address, setAddress] = useState('')
  const [selectedState, setSelectedState] = useState('')
  const [selectedDistrict, setSelectedDistrict] = useState('')
  const [selectedTaluka, setSelectedTaluka] = useState('')

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${StudentProfileApi}/${memberId}`) // Replace with your actual API endpoint
        const data = response.data

        setCity(data.villege || '')
        setAddress(data.address || '')
        setPincode(data.pincode || '')
        setSelectedState(data.state_id || '')
        setSelectedDistrict(data.district_id || '')
        setSelectedTaluka(data.taluka_id || '')

        setStudentMobNo(data.mob_no || '')
        setParentMobNo(data.parents_mobno || '')
        setClgName(data.collage_name || '')
        setStandard(data.std || '')
        setFile(data.image || null)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchData()
  }, [])

  useEffect(() => {
    axios
      .get(StateFindAllApi)
      .then((response) => {
        setStateList(response.data)
      })
      .catch((error) => {
        // console.error('Error fetching states:', error);
      })
  }, [])

  useEffect(() => {
    if (selectedState !== '') {
      axios
        .get(`${DistrictFindAllApi}/${selectedState}`)
        .then((response) => {
          setDistrictList(response.data)
        })
        .catch((error) => {
          // console.error('Error fetching districts:', error);
        })
    }
  }, [selectedState])

  useEffect(() => {
    if (selectedState !== '' && selectedDistrict !== '') {
      axios
        .get(`${TalukaFindAllApi}/${selectedState}/${selectedDistrict}`)
        .then((response) => {
          setTalukaList(response.data)
        })
        .catch((error) => {
          // console.error('Error fetching talukas:', error);
        })
    }
  }, [selectedState, selectedDistrict])

  const handleStateChange = (e) => {
    setSelectedState(e.target.value)
    setSelectedDistrict('')
    setSelectedTaluka('')
  }

  const handleDistrictChange = (e) => {
    setSelectedDistrict(e.target.value)
    setSelectedTaluka('')
  }

  const handleTalukaChange = (e) => {
    setSelectedTaluka(e.target.value)
  }

  const handlePincodeChange = (e) => {
    // setCurrentPincode(event.target.value);
    const input = e.target.value
    if (/^\d*$/.test(input) && input.length <= 6) {
      // Update state only if the input is a number and within the length limit
      setPincode(input)
    }
  }

  //add api
  const handleSubmit = async (event) => {
    event.preventDefault()

    // List of required fields
    const requiredFields = [
      { value: file, name: 'Student Photo' },
      { value: selectedState, name: 'State' },
      { value: selectedDistrict, name: 'District' },
      { value: selectedTaluka, name: 'Taluka' },
      { value: city, name: 'City/Village Name' },
      { value: address, name: 'Address' },
      { value: pincode, name: 'Pincode' },
      { value: studentMobNo, name: 'Student Mob No.' },
      { value: parentMobNo, name: 'Parent Mob No.' },
      { value: standard, name: 'Standard' },
      { value: clgName, name: 'College Name' },
    ]

    //   Check for any empty required fields
    const missingField = requiredFields.find((field) => !field.value)

    if (missingField) {
      toast.error(`${missingField.name} is required`)
      return
    }

    const formData = new FormData()

    try {
      formData.append('photo', file)
      formData.append('village', city)
      formData.append('address', address)
      formData.append('pincode', pincode)
      formData.append('state', selectedState)
      formData.append('district', selectedDistrict)
      formData.append('taluka', selectedTaluka)
      formData.append('mob_no', studentMobNo)
      formData.append('parents_mobno', parentMobNo)
      formData.append('collage_name', clgName)
      formData.append('std', standard)

      const response = await axios.put(
        `${StudentEditProfileApi}/${memberId}`,
        formData,
      )

      if (response.data == 'Failed to upload file') {
        toast.error('Failed to upload Student data!')
      } else if (response.data == 'UPDATE') {
        toast.success('Student data updated successfully!')
        navigate('/Homestudent')
      }
    } catch (error) {
      console.error('Error occurred while submitting the form:', error)
    }
  }

  const inputStyle = {
    marginTop: '-9px',
    height: '37px',
  }

  return (
    <>
      <div
        className="roomchange-container"
        style={{ display: 'flex', minHeight: '100vh' }}
      >
        {/* Sidebar on the left for desktop */}
        <div
          className="d-none d-md-block sidebar-container"
          style={{ width: '270px', flexShrink: 0 }}
        >
          <Sidebar />
        </div>

        {/* Main content on the right */}
        <div
          className="main-content flex-grow-1"
          style={{ flex: 1, backgroundColor: '#f8f9fa' }}
        >
          <Header />

          <div className="d-block d-md-none">
            <MobileNavbar />
          </div>

          <div
            className="border w-100 h-100 py-3"
            style={{ backgroundColor: '#f5f5f5ff' }}
          >
            <Container className="pb-5">
              <div
                className="shadow"
                style={{
                  backgroundColor: '#B9D9EB',
                  borderRadius: '10px',
                  padding: '20px',
                  marginTop: '20px',
                }}
              >
                <Row>
                  <h3
                    style={{ textAlign: 'center', color: 'maroon' }}
                    className="pb-3 pt-2"
                  >
                    Student Update Profile Form
                  </h3>
                </Row>

                <Row>
                  <Form.Group controlId="formFile" className="mb-3">
                    <Form.Label>Upload Photo</Form.Label>
                    <Form.Control
                      type="file"
                      accept=".png, .jpg, .jpeg"
                      onChange={(e) => setFile(e.target.files[0])}
                    />
                  </Form.Group>
                </Row>

                <Row className="mb-3">
                  <Form.Group as={Col} xs={12} sm={3} controlId="formGridState">
                    <Form.Label>State</Form.Label>
                    <Form.Select
                      defaultValue="Choose..."
                      name="state"
                      value={selectedState}
                      onChange={handleStateChange}
                      required
                    >
                      <option value="">Choose...</option>
                      {stateList.map((state) => (
                        <option key={state.id} value={state.id}>
                          {state.state_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    xs={12}
                    sm={3}
                    controlId="formGridDistrict"
                  >
                    <Form.Label>District</Form.Label>
                    <Form.Select
                      defaultValue="Choose..."
                      name="district"
                      value={selectedDistrict}
                      onChange={handleDistrictChange}
                      required
                    >
                      <option value="">Choose...</option>
                      {districtList.map((district) => (
                        <option key={district.id} value={district.id}>
                          {district.districtenname}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    xs={12}
                    sm={3}
                    controlId="formGridTaluka"
                  >
                    <Form.Label>Taluka</Form.Label>
                    <Form.Select
                      defaultValue="Choose..."
                      name="taluka"
                      value={selectedTaluka}
                      onChange={handleTalukaChange}
                      required
                    >
                      <option value="">Choose...</option>
                      {talukaList.map((taluka) => (
                        <option key={taluka.id} value={taluka.id}>
                          {taluka.talukaenname}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    xs={12}
                    sm={3}
                    controlId="formGridPincode"
                  >
                    <Form.Label>Pin code</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="pincode"
                      maxLength={6}
                      value={pincode}
                      onChange={handlePincodeChange}
                      required
                    />
                  </Form.Group>
                </Row>

                <Row className="mb-3">
                  <Form.Group as={Col} xs={12} sm={6}>
                    <Form.Label>City/Village Name</Form.Label>
                    <Form.Control
                      id="cityName"
                      placeholder="City/Village"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group as={Col} xs={12} sm={6}>
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      id="Address"
                      placeholder="House No/Road No/Colony"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group as={Col} xs={12} sm={6} className="mb-2">
                    <Form.Label>Mobile Number</Form.Label>
                    <Form.Control
                      id="mobileNumber"
                      type="text"
                      required="required"
                      value={studentMobNo}
                      name="mobile_no"
                      onChange={(e) => setStudentMobNo(e.target.value)}
                      onKeyPress={(e) => {
                        const charCode = e.which ? e.which : e.keyCode
                        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                          e.preventDefault()
                        }
                      }}
                      maxLength={10}
                      placeholder=" Mobile Number"
                    />
                  </Form.Group>

                  <Form.Group as={Col} xs={12} sm={6} className="mb-2">
                    <Form.Label>Parent's Contact No.</Form.Label>
                    <Form.Control
                      id="mobileNumber"
                      type="text"
                      required="required"
                      value={parentMobNo}
                      name="mobile_no"
                      onChange={(e) => setParentMobNo(e.target.value)}
                      onKeyPress={(e) => {
                        const charCode = e.which ? e.which : e.keyCode
                        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                          e.preventDefault()
                        }
                      }}
                      maxLength={10}
                      placeholder=" Mobile Number"
                    />
                  </Form.Group>

                  <Form.Group as={Col} xs={12} sm={8}>
                    <Form.Label>College Name</Form.Label>
                    <Form.Control
                      id="clgName"
                      placeholder="College Name"
                      value={clgName}
                      onChange={(e) => setClgName(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group as={Col} xs={12} sm={4}>
                    <Form.Label>Standard</Form.Label>
                    <Form.Control
                      id="std"
                      placeholder="Standard"
                      value={standard}
                      onChange={(e) => setStandard(e.target.value)}
                    />
                  </Form.Group>
                </Row>

                <div className="text-center m-1">
                  <Button
                    variant="primary"
                    onClick={handleSubmit}
                    className="regbtn p-3"
                    style={{
                      backgroundColor: 'rgb(0, 120, 215)',
                      color: 'white',
                    }}
                  >
                    Update Profile
                  </Button>
                </div>
              </div>
            </Container>
          </div>
        </div>
      </div>
    </>
  )
}

export default EditStudentProfile
